import { Sparkles } from "lucide-react";
import { useAssistantPanel } from "../../react/providers/AssistantPanelProvider";

// Gradient pill in the top bar that toggles the assistant side panel.
// Reads / writes the AssistantPanelProvider open state.

export function AssistantTrigger() {
    const { open, toggle } = useAssistantPanel();
    return (
        <button
            type="button"
            className={`assistant-trigger${open ? " assistant-trigger--open" : ""}`}
            aria-label={open ? "Close assistant" : "Open assistant"}
            aria-pressed={open}
            onClick={toggle}
            title={open ? "Close assistant" : "Open assistant"}
            data-testid="assistant-trigger"
        >
            <span className="assistant-trigger__tile">
                <Sparkles size={14} />
            </span>
        </button>
    );
}
